
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

import moment from "moment";
import EventsBarPreviewCard from "../EventsBarPreviewCard";
import { useSoftUIController } from "hooks/context";


function EventsBar({ events_data }) { // LAYER 4
    const [controller] = useSoftUIController();
    const { deviceLayout, miniNavbar } = controller;

    var events_data_filtered = [];
    for (var event of events_data) {
        var groups_filtered = event.groups.filter((row) => row.type == 'clearways' || typeof row.type == 'undefined');
        if (groups_filtered.length) {
            events_data_filtered.push(event);
        }
    }

    events_data = events_data_filtered.filter(event => moment(event.display_time).unix() <= moment().add(7, 'days').unix());

    const renderPreviewCards = events_data.sort((a, b) => moment(a.start_time).unix() - moment(b.start_time).unix()).map(function (event, index) {
        return (
            <Grid item key={index} xxs={12} md={6} xl={12}>
                <EventsBarPreviewCard event={event} deviceLayout={deviceLayout} miniNavbar={miniNavbar} />
            </Grid>
        )
    });

    return (
        <SoftBox px={1} py={1.5}
            sx={({ palette: { white }, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                backgroundColor: rgba(white.main, 0.8),
                borderRadius: borderRadius.xl,
                height: 'calc(100% - 24px)',
                width: '100%',
                overflow: 'auto',
                pointerEvents: 'auto'
            })}
        >
            <SoftBox sx={{ height: '100%' }}>
                <SoftBox sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <SoftTypography variant='h5'>
                        Upcoming Events This Week
                    </SoftTypography>
                </SoftBox>
                {events_data.length > 0 ? (
                    <SoftBox p={2} display='flex' flexDirection='row' sx={{
                        height: 'fit-content',
                        overflow: 'auto',

                        '::-webkit-scrollbar': {
                            backgroundColor: 'transparent',
                            height: '8px',
                            width: '6px',
                        },
                        '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                            backgroundColor: 'transparent',
                        },
                        '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                            backgroundColor: '#babac0',
                            borderRadius: '6px',
                            // border: `1px solid ${rgba(white.main, 0.8)}`,
                        },
                        '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                            display: 'none',
                        },
                    }}>
                        <Grid container spacing={3}>
                            {renderPreviewCards}
                        </Grid>
                    </SoftBox>
                ) : (
                    <SoftBox display='flex' flexDirection='row' justifyContent='center' alignItems='center' sx={{ paddingTop: '8%' }}>
                        <SoftTypography variant='h6'>
                            No Events To Show!
                        </SoftTypography>
                    </SoftBox>
                )}
            </SoftBox>
        </SoftBox>
    );
}

EventsBar.propTypes = {
    events_data: PropTypes.array,
}

export default EventsBar;
